var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('a',{attrs:{"target":_vm.target,"href":_vm.url}},[_c('img',{staticClass:"img-fluid",class:_vm.className,style:(_vm.styles),attrs:{"src":_vm.imageSource,"alt":_vm.alternateText}})]):_c('img',{staticClass:"img-fluid",class:_vm.className,style:(_vm.styles),attrs:{"src":_vm.imageSource,"alt":_vm.alternateText}})
}
var staticRenderFns = []

export { render, staticRenderFns }